// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4.5 14V4C4.5 2.9 5.4 2 6.5 2H9.5C10.6 2 11.5 2.9 11.5 4V14',
  'M4.5 6H3C2.17 6 1.5 6.67 1.5 7.5V12.5C1.5 13.33 2.17 14 3 14H13C13.83 14 14.5 13.33 14.5 12.5V9.5C14.5 8.67 13.83 8 13 8H11.5',
  'M8 4.4V7M6.7 5.7H9.3',
  'M6.7 14V11.35C6.7 10.88 7.08 10.5 7.55 10.5H8.45C8.92 10.5 9.3 10.88 9.3 11.35V14',
];
